import React, { useRef, useState } from 'react'
import { OverlayPanel } from 'primereact/overlaypanel';
import { Dependent,  DependentReservation} from '../../constants/ProIcons'
import _ from 'lodash'
import { useClientService } from '../../hooks/useClientService';
import ProClientDetails from './ProClientDetails';
import ProAvatar from '../common/ProAvatar';

const ProClient = ({data, clickable = true, image= false})=>{
    const op = useRef(null);
    const [clientData, setClientData] = useState({})
    const {GetClientDetails} = useClientService();

    const handleClick = async (e, assignmentId)=>{
        if(clickable){
            op.current.toggle(e);
            const data = await GetClientDetails(assignmentId) // Call API Inside this function
            setClientData(data);
        }
    }
    
    const clientNameStyle = data.latestAssignment?{position: 'relative' } : {position: 'relative', fontStyle:"italic", color:"#808080"}
   if(_.get(data.occupantType, "code") === "CLIENT")
        if(image)
        return <div>
            <ProAvatar>
                
            </ProAvatar>
        </div>
        else
        return <div>
            <i className ={_.isEqual(data.occupancyStatus, "OCCUPIED")?"fa fa-user": "fal fa-user"} onClick={(e)=>handleClick(e, data.assignmentId)} aria-hidden="true" style={{ color: '#34436d', fontSize: 15, position: 'relative', marginLeft:"20px", cursor:'pointer' }}>               
                <span className='tree-node' style={clientNameStyle}>{`${data.client.lastName} ${data.client.firstName} (${data.client.id})`}
                {_.get(data, "reservationStatus") && _.isEqual(data.reservationStatus, "RESERVED") && _.isEqual(data.occupancyStatus, "UNOCCUPIED")&& <span  style={{ fontSize: 11, color:"#808080", position: 'relative' }}> - Reserved</span>}</span>
            </i>
            {clickable && <OverlayPanel ref={op} showCloseIcon id="overlay_panel" style={{width: '550px'}} >
                <ProClientDetails clientData={clientData}/>
             </OverlayPanel>}
        </div> 
    if(_.get(data.occupantType, "code") === "DEPENDENT")      
        return  <div>
                <i className ="fas" aria-hidden="true" style={{ color: '#579800', fontSize: 12, position: 'relative', marginLeft:"20px", cursor:'pointer'}} onClick={(e)=>handleClick(e, data.assignmentId)}>  
                    {_.isEqual(data.occupancyStatus, "OCCUPIED")?<Dependent/> : <DependentReservation/> }          
                   <span className='tree-node' style={{...clientNameStyle, top: "-2px" }}>{`${data.client.dependentName} (${data.client.lastName} ${data.client.firstName} #${data.client.id})`}
                    { _.get(data, "reservationStatus") && _.isEqual(data.reservationStatus, "RESERVED")  && _.isEqual(data.occupancyStatus, "UNOCCUPIED")&& <span  style={{ fontSize: 11,color:"#808080", position: 'relative' }}> - Reserved</span>}</span>
                </i> 
               {clickable && <OverlayPanel ref={op} showCloseIcon id="overlay_panel" style={{width: '450px'}} >
                    <ProClientDetails clientData={clientData}/>
                </OverlayPanel>}
            </div>

}

export default ProClient;